import { render, staticRenderFns } from "./ChatBalao.vue?vue&type=template&id=791d4e16&scoped=true"
import script from "./ChatBalao.vue?vue&type=script&lang=js"
export * from "./ChatBalao.vue?vue&type=script&lang=js"
import style0 from "./ChatBalao.vue?vue&type=style&index=0&id=791d4e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d4e16",
  null
  
)

export default component.exports